import OWContainer from 'styles/styled-components/ow-container';
import useController from '../controllers/product-categories-controller';
import { MaterialReactTable } from 'material-react-table';

export const ProductCategoriesRoute = () => {
    const { tableSettings } = useController();

    return (
        <OWContainer>
            <MaterialReactTable table={tableSettings} />
        </OWContainer>
    );
};
